import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getAllCompany = async () => {
    const { data } = await axios.get(API_ROUTES.COMPANIES);
    return data;
};

export const softDeleteCompany = async (id) => {
    await axios.put(`${API_ROUTES.COMPANIES_DELETE}/${id}`);
};